import type { BillingCycle } from '@yawi/types';

const GB_IN_BYTES = 1073741824;

export interface PlanWizardData {
  code: string;
  name: string;
  description: string | null;
  billingCycle: BillingCycle;
  basePrice: number;
  includedUnits: number;
  includedUsers: number;
  includedStorageBytes: number;
  includedNotifications: number;
  extraUnitPrice: number;
  extraUserPrice: number;
  extraStoragePricePerGb: number;
  extraNotificationPrice: number;
  trialDays: number;
  isActive: boolean;
  isPublic: boolean;
  sortOrder: number;
  features: Record<string, boolean>;
}

export const initialPlanData: PlanWizardData = {
  code: '',
  name: '',
  description: '',
  billingCycle: 'MONTHLY',
  basePrice: 0,
  includedUnits: 10,
  includedUsers: 20,
  includedStorageBytes: GB_IN_BYTES,
  includedNotifications: 1000,
  extraUnitPrice: 10,
  extraUserPrice: 5,
  extraStoragePricePerGb: 0.5,
  extraNotificationPrice: 0.01,
  trialDays: 14,
  isActive: true,
  isPublic: true,
  sortOrder: 0,
  features: {},
};

export interface PlanStepProps {
  data: PlanWizardData;
  onChange: (data: Partial<PlanWizardData>) => void;
  onValidChange: (isValid: boolean) => void;
}
